import React, { useEffect } from 'react';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import Box from '@mui/material/Box';

import Car, { allCarsAtom } from '../atoms/allCarsAtom';
import ConvertTime from '../converters/timestampConverter';

import EventCard from '../org/EventCard';
import LiveBoard from '../org/LiveBoard';
import { API_BASE } from '../org/scoring-types';

// Standalone organizer page. No react-grid-layout here — we want a fresh,
// fixed two-row layout: event card on top, tabbed live board filling the rest.
const OrgGrid: React.FC = () => {
  const [, setAllCars] = useAtom(allCarsAtom);

  // Load Cars so the EventCard dropdown is populated even on a fresh load
  // (the navbar's CarDropdown only runs on /dashboard).
  const { data } = useQuery({
    queryKey: ['org-allCars'],
    queryFn: async () => (await axios.get<Car[]>(`${API_BASE}/api/allCars`)).data,
  });

  useEffect(() => {
    if (!data) return;
    setAllCars(
      data.map((c) => ({
        ...c,
        LastReception: ConvertTime(c.LastReception),
        StartTime:     ConvertTime(c.StartTime),
        EndTime:       ConvertTime(c.EndTime),
      })),
    );
  }, [data, setAllCars]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 64px)',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <EventCard />
      <LiveBoard />
    </Box>
  );
};

export default OrgGrid;
